import { queryOptions } from '@tanstack/react-query';

import apiClient from '@/constants/http';
import { Logger } from '@/utils/logging';

import type { WaitlistTimeSlotsResponse } from './types';

async function getWaitlistTimeSlots(
  waitlistCustomerId: string,
  attemptId: string,
): Promise<WaitlistTimeSlotsResponse> {
  try {
    const { data } = await apiClient.get<WaitlistTimeSlotsResponse>(
      `/v1/customer/waiting-list-slot-times/${waitlistCustomerId}/${attemptId}`,
    );

    return data;
  } catch (error) {
    Logger.error('getWaitlistTimeSlots failed', {
      error,
      waitlistCustomerId,
      attemptId,
    });
    throw error;
  }
}

export const waitlistTimeSlotsQueryOptions = (
  waitlistCustomerId: string,
  attemptId: string | null,
) =>
  queryOptions({
    queryKey: ['waitlistTimeSlots', waitlistCustomerId, attemptId],
    queryFn: () => getWaitlistTimeSlots(waitlistCustomerId, attemptId ?? ''),
    enabled: !!waitlistCustomerId && !!attemptId,
  });
